// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"511322fd","228":"14151f16","272":"8ec62dfe","521":"658eec4e","549":"350eec54","666":"b2c655b9","816":"678f40e0","842":"8d66336a","930":"f74e2ef2","996":"d9917975"}[chunkId] + ".chunk.js";
};